module.exports = __webpack_public_path__ + "static/scg.transparent-4968d41473b4822b4b2f32ba14881710.png";